var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isShowTopLabel
        ? _c("TopLabel", [_vm._v(_vm._s(_vm.topLabel))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CheckboxMultiple",
        {
          staticClass: "checkboxComponent",
          attrs: { "checkbox-id": _vm.checkboxId, disabled: _vm.disabled },
          on: { change: _vm.clicked },
          model: {
            value: _vm.handleInputValue,
            callback: function ($$v) {
              _vm.handleInputValue = $$v
            },
            expression: "handleInputValue",
          },
        },
        [
          _c(
            "span",
            { staticClass: "label", class: { disabled: _vm.disabled } },
            [_vm._v(_vm._s(_vm.label))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }